<template>
    <div :class="className">
        <slot name="before" />
        <div class="quizier-image-wrapper" :class="wrapperClass" v-bind="$attrs">
            <div class="media-meta" v-if="(author || link) && showMeta">
                <span class="media-author" v-if="author">{{ author }}</span>
                <span class="media-divider" v-if="author && link"> / </span>
                <span class="media-link" v-if="link">
                    <a :href="link" target="_blank">
                        {{ domain(link) }}
                    </a>
                </span>
            </div>
            <slot name="meta" />
            <div v-if="src && format == 'bg'" :title="caption" :style="{ backgroundImage: `url('${src}')` }"
                :class="imgClass" />
            <img :src="src" :title="caption" :alt="alt" v-else-if="src" :class="imgClass">
            <slot name="after-image" />
        </div>
        <slot name="after" />
    </div>
</template>
<script>
export default {
    inheritAttrs: false,
    props: {
        media: {
            type: [Array, Object, String],
            required: false
        },
        className: {
            type: [String, Array],
            default: null
        },
        imgClass: {
            type: [Array, Object, String],
            default: null
        },
        wrapperClass: {
            type: [Array, Object, String],
            default: null
        },
        format: {
            type: String,
            default: 'img'
        },
        showMeta: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        image: function () {
            return this.media instanceof Array ? this.media[0] : this.media
        },
        src: function () {
            return this.image?.source
        },
        metadata: function () {
            return this.image?.options?.metadata
        },
        alt: function () {
            return this.metadata?.alt
        },
        caption: function () {
            return this.metadata?.caption
        },
        author: function () {
            return this.metadata?.author
        },
        link: function () {
            return this.metadata?.link
        },
    },
    methods: {
        domain: function (url) {
            var domain;
            //find & remove protocol (http, ftp, etc.) and get domain
            if (url.indexOf("://") > -1) {
                domain = url.split('/')[2];
            }
            else {
                domain = url.split('/')[0];
            }

            //find & remove www
            if (domain.indexOf("www.") > -1) {
                domain = domain.split('www.')[1];
            }

            domain = domain.split(':')[0]; //find & remove port number
            domain = domain.split('?')[0]; //find & remove url params

            return domain;
        },
    },
}
</script>
